// safeNext returns a same-app pathname-only redirect target. Anything that
// could be interpreted as cross-origin — empty, absolute URL, protocol-
// relative `//host`, backslash tricks, anything outside a strict path
// charset — falls back to the supplied default.
//
// Why this is its own module: the post-magic-link redirect (Verify.tsx) trusts
// a query-string param, which is a classic open-redirect vector. Pulling the
// validation into a pure function makes it testable and prevents a dev later
// from re-introducing the hole by inlining `navigate(params.get('next'))`.
//
// The app only ever redirects to internal routes (/today, /dashboard,
// /training, /review, /insurance), so an allowlist of path characters with no
// query/fragment is correct *and* tighter than parsing.
const SAFE_PATH = /^\/[A-Za-z0-9_\-./]*$/;

export function safeNext(raw: string | null | undefined, fallback = '/today'): string {
  if (typeof raw !== 'string') return fallback;
  if (raw.length === 0 || raw.length > 256) return fallback;
  // Single leading slash only — `//host` is protocol-relative and would let
  // browsers resolve to an external origin.
  if (raw.startsWith('//')) return fallback;
  // Reject `..` segments to prevent path traversal weirdness in nested layouts.
  if (raw.includes('..')) return fallback;
  if (!SAFE_PATH.test(raw)) return fallback;
  return raw;
}
